export type Tooltip = {
  content: string;
  placement?: TooltipPlacement;
};

export enum TooltipPlacement {
  TOP = 'top',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  LEFT = 'left',
}
